/* eslint-disable react/prop-types */
import React, { forwardRef } from 'react'
import { Button, Grid, Icon, IconButton, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { disabledColor, mainBlue, mainWhite } from 'utils/constants/ColorTheme'
import { getHoverColor } from 'utils/ColorUtil'

export const ButtonMUI = styled(forwardRef((props, ref) => (
    <Button
        {...props}
        variant={props.variant || 'contained'}
        sx={{
            '&:focus': { backgroundColor: (theme) => `${props.variant === 'outlined' ? 'white' : theme.palette.primary.main} !important` },
            ...props.sx,
        }}
        ref={ref}
    />)))({
})

export const IconButtonMUI = styled((props) => {
    const color = props.color || mainBlue
    const bgColor = !props.disabled ? color : disabledColor
    return (
        <Tooltip title={props.tooltip}>
            <Grid
                {...props}
                sx={{
                    padding: '1.355rem',
                    borderRadius: '50%',
                    backgroundColor: bgColor,
                    cursor: props.disabled ? 'cursor' : 'pointer',
                    '&:hover': {
                        backgroundColor: !props.disabled && getHoverColor(bgColor),
                    },
                    '&:focus': {
                        backgroundColor: !props.disabled && bgColor,
                    },
                    ...props.sx,
                }}
                onClick={!props.disabled && props?.onClick}
            >
                <Icon sx={{ color: mainWhite, fontSize: '1.6rem' }}>{props?.icon}</Icon>
            </Grid>
        </Tooltip>
    )
})({
})

// Just set position: 'relative' on the parent component
export const FileIconMUI = styled((props) => (
    <Tooltip title={props.tooltip} placement={'top'}>
        <IconButton
            aria-label='change picture'
            component='label'
            sx={{
                position: 'absolute',
                top: '0px',
                right: '25%',
                backgroundColor: '#35609f',
                color: 'white',
                borderRadius: '50%',
                fontSize: '1.5rem',
                width: '3rem',
                height: '3rem',
                padding: '0.75rem',
                '&:hover': {
                    backgroundColor: '#6dafff',
                },
                '&:focus': {
                    backgroundColor: '#35609f',
                },
            }}
            {...props}
        >
            <input hidden accept='image/*' type='file' multiple />
            <Icon>{props?.icon || 'edit'}</Icon>
        </IconButton>
    </Tooltip>
))({
})
